import React from "react";
import { useLoadScript } from "@react-google-maps/api";

const libraries = ["places"];

const GoogleMapsLoader = ({ children }) => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_KEY,
    libraries,
  });

  if (loadError) return <div>Failed to load Maps</div>;
  if (!isLoaded) return <div>Loading Autocomplete...</div>;
  return <>{children}</>;
};

export default GoogleMapsLoader;